import React from 'react';
import { createPortal } from 'react-dom';
import { useDropdown } from './hooks/useDropdown';
import { useDropdownPosition } from './hooks/useDropdownPosition';
/*
 * This component is based on @reach/dialog.
 * https://github.com/reach/reach-ui/blob/main/packages/dialog/src/index.tsx
 * https://reach.tech/dialog
 */
const DropdownMenu = ({ children, testId = 'store-dropdown-menu', style, ...otherProps }) => {
    const { isOpen, close, dropdownItemsRef, selectedDropdownItemIndexRef, id } = useDropdown();
    const dropdownPosition = useDropdownPosition();
    const childrenLength = React.Children.toArray(children).length;
    const handleDownPress = () => {
        if (selectedDropdownItemIndexRef.current < childrenLength - 1) {
            selectedDropdownItemIndexRef.current++;
        }
        else {
            selectedDropdownItemIndexRef.current = 0;
        }
        dropdownItemsRef?.current[selectedDropdownItemIndexRef.current]?.focus();
    };
    const handleUpPress = () => {
        if (selectedDropdownItemIndexRef.current > 0) {
            selectedDropdownItemIndexRef.current--;
        }
        else {
            selectedDropdownItemIndexRef.current = childrenLength - 1;
        }
        dropdownItemsRef?.current[selectedDropdownItemIndexRef.current]?.focus();
    };
    const handleHomePress = () => {
        selectedDropdownItemIndexRef.current = 0;
        dropdownItemsRef?.current[selectedDropdownItemIndexRef.current]?.focus();
    };
    const handleEndPress = () => {
        selectedDropdownItemIndexRef.current = childrenLength - 1;
        dropdownItemsRef?.current[selectedDropdownItemIndexRef.current]?.focus();
    };
    const handleEscapePress = () => {
        close?.();
    };
    const handleBackdropKeyDown = (event) => {
        if (event.defaultPrevented || event.key === 'Enter') {
            return;
        }
        event.preventDefault();
        event.key === 'Escape' && handleEscapePress();
        event.key === 'ArrowDown' && handleDownPress();
        event.key === 'ArrowUp' && handleUpPress();
        event.key === 'Home' && handleHomePress();
        event.key === 'End' && handleEndPress();
        event.stopPropagation();
    };
    const clearChildrenReferences = () => {
        dropdownItemsRef.current = [];
        return null;
    };
    return isOpen
        ? createPortal(React.createElement("div", { role: "presentation", "data-store-dropdown-overlay": true, onKeyDown: handleBackdropKeyDown, "data-testid": `${testId}-overlay` },
            React.createElement("div", Object.assign({ role: "menu", "aria-orientation": "vertical", "data-store-dropdown-menu": true, "data-testid": testId, style: { ...dropdownPosition, ...style }, id: id }, otherProps), children)), document.body)
        : clearChildrenReferences();
};
export default DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map